// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

const EcommerceKeyShowOrHideExpired = (props) => {

    const {
        linkToBack,
        messageExpired,
        messageNonExpired,
        newRequestText,
        textBack, 
        textNewRequest,
        triggerNewRequest
    } = props;

    return ( 
        <div className="ecommerce-key-request-view__container">
            <div className="code-confirmation-success__label">
                {messageNonExpired}
            </div>
            <div className="ecommerce-key-request-view__password--expired" />
            <div className="ecommerce-key-request-view__time-message">
                {messageExpired}
            </div>
            {newRequestText}
            <OKButton modifier="link-emphasize" onClick={triggerNewRequest}>
                {textNewRequest}
            </OKButton>
            <div className="ecommerce-key-request-view__footer">
                <OKLink modifier="emphasize" to={linkToBack} >
                    {textBack}
                </OKLink>
            </div>
        </div>
     );
}

EcommerceKeyShowOrHideExpired.propTypes = {
    messageExpired: PropTypes.string,
    messageNonExpired: PropTypes.string,
    messageShortNonExpired: PropTypes.string,
    newRequest: PropTypes.string,
    newRequestText: PropTypes.string,
    textBack: PropTypes.string,
    textNewRequest: PropTypes.string,
    linkToBack: PropTypes.string,
    triggerNewRequest: PropTypes.func.isRequired
};

module.exports = EcommerceKeyShowOrHideExpired;